import React from 'react';
import { Col, Row } from '../../components/RowCol';
import { Team } from './Game';
import styles from '../../style';
import Spacer from '../../components/Spacer';

type Props = {
	scores: Record<Team, number>;
}

const withCommas = (x: number) => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

const format = (score: number) => {
	if (score >= 0) {
		return '$' + withCommas(score);
	} else {
		return '-$' + withCommas(Math.abs(score));
	}
};

const Scoreboard: React.FC<Props> = ({
	scores,
}) => {
	return (
		<Row center style={{
			height: '200px',
		}}>
			{Object.entries(scores).map(([team, score]) => (
				<React.Fragment
					key={team}
				>
					<Col alignCenter>
						<Row center style={{
							fontFamily: styles.scoreFont,
							fontSize: styles.scoreFontSize,
							backgroundColor: styles.scoreBackground,
							color: styles.scoreColor,
							...score < 0 ? {
								color: styles.scoreColorNegative,
							} : {},
							padding: '10px 10px 5px 10px',
							width: '156px',
							height: '52px',
							textAlign: 'center',
							whiteSpace: 'nowrap',
						}}>
							{format(score)}
						</Row>

						<Spacer vertical={5} />

						<Row center style={{
							fontFamily: (
								team === 'A'
									? styles.teamAFont
									: styles.teamBFont
							),
							fontSize: styles.teamFontSize,
							background: styles.teamBackground,
							color: styles.scoreColor,
							padding: '10px 10px 5px 10px',
							width: '156px',
							height: '102px',
							textAlign: 'center',
							lineHeight: '30px',
						}}>
							Team {team}
						</Row>
					</Col>
					{team === 'A' && (
						<Spacer horizontal={20} />
					)}
				</React.Fragment>
			))}
		</Row>
	);
};

export default Scoreboard;
